import { useState } from 'react';
import { experience } from '../data';
import s from './Experience.module.css';

export default function Experience() {
  const [open, setOpen] = useState(-1);
  return (
    <section id="experience" className="sec" aria-label="Experience">
      <div className="sec-inner">
        <div className="sec-top">
          <div><div className="sec-num">04 — Journey</div><h2 className="sec-h">Work History</h2></div>
          <p className="sec-p">8 years across startups, agencies and enterprises.</p>
        </div>
        <div className={s.list}>
          {experience.map((e, i) => (
            <div key={i} className={s.item} onClick={() => setOpen(open===i?-1:i)}>
              <div className={s.left}>
                <div className={`${s.dot} ${open===i?s.dotActive:''}`} />
                <div>
                  <div className={`${s.title} ${open===i?s.titleActive:''}`}>{e.title}</div>
                  <div className={s.co}>{e.company}</div>
                  {open===i && <p className={s.desc}>{e.desc}</p>}
                </div>
              </div>
              <div className={s.period}>{e.period}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
